import { TravelCompany } from '../../lib/types/models/travel-company/travel-company'
import { TravelCompanyInput } from '../../lib/types/models/travel-company/travel-company-input'
import { UpdateInput } from '../../lib/types/utils'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function updateTravelCompany(data: UpdateInput<TravelCompanyInput>) {
  const { id, ...rest } = data
  return restApiClient
    .url(constructApiUrl(API.travelCompanies.update.url, { id }))
    .patch<TravelCompany>(rest)
}
